import type { LoginPageViewProperties } from './index';

export function captureLoginRoutePageView(properties: LoginPageViewProperties = {}): void {
  if (typeof window === 'undefined') {
    return;
  }

  void import('./index').then(({ analyticsService }) => {
    analyticsService.captureLoginPageView(properties);
  });
}
